const phase2FieldsBirthday = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Campaign Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  body: {
    value: '',
    error: null,
    name: 'body',
    placeholder: 'Text Message',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: 'length',
    hasBlurred: false,
    inputType: 'textarea',
    charLimit: 160,
  },
  send_days_before: {
    value: '',
    error: null,
    name: 'send_days_before',
    placeholder: 'Days Before Birthday',
    breed: 'points',
    touched: false,
    isRequired: true,
    validationType: 'number',
    hasBlurred: false,
    inputType: 'text',
  }
};

export default phase2FieldsBirthday;



/** WEBPACK FOOTER **
 ** ./src/forms/autoCampaign/autoCampaignPhase2Birthday.js
 **/